<template>
	<SearchListLayoutCludo
		class="d-search-page"
		v-bind="{
			...$attrs,
		}"
	>
		<template #customHeader>
			<div class="pt-xs/v">
				<div
					class="
						d-search-page__search-fields
						grid grid-cols-12
						gap-x-3xs/h gap-y-2xs/v
						pb-sm/v
					"
				>
					<div class="col-span-12 flex justify-end items-center">
						<div
							id="cludo-search-input"
							class="c-search-text-input"
							style="position: relative"
						>
							<input
								id="cludo-input"
								:aria-label="
									language === 'da'
										? 'Søg i alt indhold'
										: 'Search in all content'
								"
								type="search"
								value=""
								name="text"
								:placeholder="
									language === 'da'
										? 'Søg i alt indhold'
										: 'Search in all content'
								"
								class="
									flex-shrink flex-grow
									w-full
									h-full
									pl-sm/h
									py-20
									text-input text-theme
									bg-transparent
									placeholder-gray-dark
								"
							/>
							<div
								class="
									flex-shrink-0 flex-grow-0 flex
									items-center
									gap-8
									w-auto
									h-full
									p-8
								"
							>
								<button
									:aria-label="
										language === 'da'
											? 'Udfør søgning'
											: 'Perform search'
									"
									type="button"
									class="
										c-base-button
										d-search-page__button-in-search
										w-48
										>=768:w-52
										h-48
										>=768:h-52
										p-0
										rounded-full
									"
								>
									<svg
										viewbox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										aria-hidden="true"
										focusable="false"
										class="w-18 h-18"
									>
										<path
											d="M11.47 11.059l5.88 5.878"
											stroke="currentColor"
											stroke-width="1.5"
										/>
										<path
											d="M13.66 7.14a6.108 6.108 0 01-6.11 6.108 6.108 6.108 0 116.11-6.108z"
											stroke="currentColor"
											stroke-width="1.5"
										/>
									</svg>
								</button>
								<button
									:aria-label="
										language === 'da'
											? 'Luk søgning'
											: 'Close search'
									"
									type="button"
									class="
										c-base-button
										d-search-page__button-in-search
										bg-transparent
										hover:bg-theme-10
										border border-theme
										text-theme
										w-48
										>=768:w-52
										h-48
										>=768:h-52
										p-0
										rounded-full
									"
									@click="goBack"
								>
									<svg
										viewbox="0 0 10 11"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										aria-hidden="true"
										focusable="false"
										class="w-14 h-14"
									>
										<path
											d="M1 9.5l8-8"
											stroke="currentColor"
											stroke-width="1.5"
											vector-effect="non-scaling-stroke"
										/>
										<path
											d="M1 1.5l8 8"
											stroke="currentColor"
											stroke-width="1.5"
											vector-effect="non-scaling-stroke"
										/>
									</svg>
								</button>
							</div>

							<label
								for="cludo-input"
								class="cludo-help-text"
								v-html="cludoHelpText"
							>
							</label>
						</div>
					</div>
				</div>
			</div>
		</template>
	</SearchListLayoutCludo>
</template>

<script>
import SearchListLayoutCludo from '~/components/main/SearchListLayoutCludo';
import BaseButton from '~/components/main/Base/BaseButton.vue';
import { cookieInformationData } from '~/components/shared/CookieInformation';

export default {
	name: 'MainSearchList',

	components: {
		SearchListLayoutCludo,
		// eslint-disable-next-line vue/no-unused-components
		BaseButton,
	},
	inheritAttrs: false,

	data() {
		return {
			enableCludo: false,
		};
	},

	head() {
		const cludoCanTrack = !!this.cookieInformation?.categories?.statistic;
		return {
			link: [
				{
					rel: 'stylesheet',
					type: 'text/css',
					href: 'https://customer.cludo.com/templates/3262/new/dist/styles/cludo-search-results.css',
				},
			],
			script: [
				{
					hid: 'cludo-config',
					skip: false,
					innerHTML: `
					window.cludo_engineId = '${this.language === 'da' ? 13783 : 14571}';
					window.cludo_language = '${this.language}';
					window.cludo_searchUrl = '${this.searchPageUrl}';
					window.cludo_searchInputSelectors = ["#cludo-search-input"];
					window.cludo_canUserBeTracked = function() { return ${cludoCanTrack}; };`,
					body: true,
				},
				{
					hid: 'cludo-search',
					skip: !this.enableCludo,
					type: 'text/javascript',
					src: 'https://customer.cludo.com/scripts/bundles/search-script.min.js',
					defer: true,
					body: true,
				},
				{
					hid: 'cludo-search-results',
					skip: !this.enableCludo,
					type: 'text/javascript',
					src: 'https://customer.cludo.com/templates/3262/new/dist/js/cludo-search-results.js',
					defer: true,
					onload: '',
					body: true,
				},
			],
			__dangerouslyDisableSanitizersByTagID: {
				'cludo-config': ['innerHTML'],
			},
		};
	},

	computed: {
		cookieInformation() {
			return cookieInformationData;
		},
		backLink() {
			return (
				this.$route.params.from || this.$store.state.site?.url || '/'
			);
		},
		language() {
			return this.$store.state?.site?.culture.split('-')[0] || 'da';
		},
		searchPageUrl() {
			return this.$store.state?.site?.searchPage?.url || '/da/soeg/';
		},
		cludoHelpText() {
			let helpText = '';
			if (this.language === 'da') {
				helpText =
					'Afgræns din søgning ved at sætte "" omkring søgeudtrykket for at finde den præcise ordlyd. Brug AND mellem søgeord, hvis du vil sikre, at alle ordene indgår i søgeresultatet.';
			} else {
				helpText =
					'Narrow your search by putting quotation marks ("") around the search term to find the exact wording. Use AND between keywords if you want to ensure that all the words are included in the search results.';
			}

			return helpText;
		},
	},

	mounted() {
		// Enable Cludo search and search results, needed to ensure the config is set before scripts are loaded
		this.enableCludo = true;

		const input = document.getElementById('cludo-input');
		if (input) {
			input.focus();
		}
	},

	methods: {
		goBack() {
			this.$router.push(this.backLink);
			if (this.$route.params.from) {
				this.$router.back();
			}
		},
	},
};
</script>

<style lang="postcss">
.d-search-page {
	.c-search-text-input {
		@apply w-full h-auto flex items-center rounded-full bg-white;
	}
}
</style>
